module.exports = __webpack_public_path__ + "img/wall-patch.4c1d100e.png";